import React, { Component } from "react";
import ReactDOM from "react-dom";

// Components
import Loader from "./loader";
import styles from "./loader-overlay.scss";
import { Fade } from "../transition";

type Props = {
  minTime: Number,
  message: String,
  show: Boolean
};
type State = {};

export default class LoaderOverlay extends Component {
  props: Props;
  state: State = {
    show: false,
    lastShow: 0
  };

  el: HTMLDivElement;
  timeout: Number;

  constructor(props) {
    super(props);
    this.el = document.createElement("div");
    document.body.appendChild(this.el);
  }

  static defaultProps = {
    minTime: 1000
  };

  static getDerivedStateFromProps(props, state) {
    return {
      lastShow: props.show && !state.show ? Date.now() : state.lastShow,
      show:
        props.show ||
        (state.show && Date.now() - state.lastShow < props.minTime)
    };
  }

  componentWillUnmount() {
    this.el.remove();
    clearTimeout(this.timeout);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.show && !this.props.show) {
      const duration = this.props.minTime - (Date.now() - this.state.lastShow);
      if (duration > 0) {
        this.timeout = setTimeout(() => {
          this.setState({ show: false });
        }, duration);
      }
    }

    if (this.props.show) {
      clearTimeout(this.timeout);
    }
  }

  renderOverlay() {
    return (
      <Fade
        className={styles.root + " column v-center h-center"}
        in={this.state.show}
      >
        <Loader random={!this.props.message} message={this.props.message} />
      </Fade>
    );
  }

  render() {
    return ReactDOM.createPortal(this.renderOverlay(), this.el);
  }
}
